import React, { Component } from "react";
import { styles } from "../../../../../../ReactConst";
import { StyleRoot } from "radium";
import Close from "../../../../../../Icons/Close";
import iconValider from "../../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import ModaleConfirmationDelete from "./ModaleConfirmationDelete";
import TreatementItems from "./TreatementItems";
import _ from "lodash";
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

export default class ModalTreatement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      styleFadeIn: true,
      ordonnanceState: false,
      deletemodal: false,
      ListTreatment: [],
      TraitementName: "",
      NewTraitementDescription: "",
      TraitementName: "",
      deleteIndex: "",
      EditTraitementDescription: "",
      EditTraitementName: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.AddNewTreatement = this.AddNewTreatement.bind(this);
    this.updateListTreatement = this.updateListTreatement.bind(this);
    this.validerTreatement = this.validerTreatement.bind(this);
    this.confirmDeleteTreatement = this.confirmDeleteTreatement.bind(this);
    this.editTraitement = this.editTraitement.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  editTraitement = (data) => {
    if (data.name === "EditTraitementName") {
      var tab = this.state.ListTreatment;
      tab[data.index].titre = data.value;
      tab[data.index].id = null;
      this.setState({
        ListTreatment: tab,
      });
    } else if (data.name === "EditTraitementDescription") {
      var tab = this.state.ListTreatment;
      tab[data.index].description = data.value;
      tab[data.index].id = null;

      this.setState({
        ListTreatment: tab,
      });
    }
  };

  confirmDeleteTreatement = (e) => {
    e.preventDefault();
    var tab = this.state.ListTreatment;
    tab.splice(this.state.deleteIndex, 1);
    this.setState({
      deleteIndex: "",
      deletemodal: false,
      ListTreatment: tab,
    });
  };

  validerTreatement(e) {
    e.preventDefault();
    if (
      this.state.ListTreatment.every((element) =>
        _.isNumber(element.idOrdonnance)
      )
    ) {
      this.props.AddEditTreatement(this.state.ListTreatment);
    }
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  componentDidMount() {
    this.setState({
      styleFadeIn: true,
      ListTreatment: this.props.ListTreatment,
    });
  }

  updateListTreatement = (data, index, didChange) => {
    let tab = this.state.ListTreatment;
    tab[index].idOrdonnance = data;
    let noIdData = Object.assign(
      {},
      {
        description: tab[index].description,
        idOrdonnance: tab[index].idOrdonnance,
        titre: tab[index].titre,
        id: null,
      }
    );
    let cleanData = didChange ? noIdData : tab[index];
    tab[index] = cleanData;
    this.setState({
      ListTreatment: tab,
    });
  };

  showordonnanceModal = (e) => {
    e.preventDefault();
    this.setState({
      ordonnanceState: true,
    });
  };
  showDeleteModal = (e, index) => {
    e.preventDefault();
    this.setState({
      deletemodal: true,
      deleteIndex: index,
    });
  };

  closeModal = (e) => {
    e.preventDefault();

    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.handleCloseModal();
    }, 400);
  };

  handleCloseDelete = () => {
    this.setState({
      deletemodal: false,
      ordonnanceState: false,
    });
  };

  AddNewTreatement = (e) => {
    e.preventDefault();
    var data = {};
    data.description = this.state.NewTraitementDescription;
    data.idOrdonnance = "";
    data.titre = this.state.TraitementName;
    data.id = null;
    var TreatementTab = this.state.ListTreatment;
    TreatementTab.push(data);
    this.setState({
      ListTreatment: TreatementTab,
    });

    this.setState({
      TraitementName: "",
      NewTraitementDescription: "",
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.ListTreatment === undefined) {
      this.setState({
        ListTreatment: [],
      });
    }
  }

  render() {
    return (
      <StyleRoot>
        <div
          className="modal  modal-skin  show"
          id="modalTreatement"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeModal}
                  />
                </button>
                <div className="modal-body fiche-enfant">
                  <h5 className="modal-title mb-5">Détails du traitement</h5>
                  <p className="bottom-space" />
                  {this.state.ListTreatment !== undefined &&
                  this.state.ListTreatment.length > 0
                    ? this.state.ListTreatment.map((element, index) => (
                        <TreatementItems
                          item={element}
                          index={index}
                          handleChange={this.handleChange}
                          showordonnanceModal={this.showordonnanceModal}
                          values={this.state}
                          showDeleteModal={this.showDeleteModal}
                          kidItem={this.props.kidItem}
                          updateListTreatement={this.updateListTreatement}
                          editTraitement={this.editTraitement}
                        />
                      ))
                    : ""}

                  <section className="content-section">
                    <div className="row align-items-center mb-3">
                      <div className="col-md-5">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nom du traitement"
                            style={{ paddingLeft: 20 }}
                            name="TraitementName"
                            value={this.state.TraitementName || ""}
                            onChange={this.handleChange("TraitementName")}
                          />
                        </div>
                      </div>
                      <div className="col-md-5 d-flex align-items-right"></div>
                      <div className="col-md-2 d-flex align-items-center">
                        <button
                          className="action-line add"
                          disabled={
                            this.state.NewTraitementDescription == "" ||
                            this.state.TraitementName == ""
                          }
                          onClick={(e) => this.AddNewTreatement(e)}
                        />
                      </div>
                    </div>
                    <div className="row align-items-center mb-3">
                      <div className="col-md-10">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Description"
                            style={{ paddingLeft: 20 }}
                            name="NewTraitementDescription"
                            value={this.state.NewTraitementDescription || ""}
                            onChange={this.handleChange(
                              "NewTraitementDescription"
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="d-flex justify-content-center">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <button
                          type="submit"
                          className="btn-white btn-border btn-valid"
                          data-dismiss="modal"
                          onClick={this.closeModal}
                        >
                          Annuler
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button
                          type="submit"
                          className="btn-gradient btn-valid margin-left"
                          data-dismiss="modal"
                          data-toggle="modal"
                          data-target="#modalOrdonnance"
                          onClick={(e) => this.validerTreatement(e)}
                        >
                          <img
                            src="img/icon-check-white.svg"
                            className="img-fluid"
                            alt=""
                          />
                          <IconValider />
                          Valider
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {this.state.deletemodal === true ? (
            <ModaleConfirmationDelete
              handleCloseDelete={this.handleCloseDelete}
              kidItem={this.props.kidItem}
              confirmDeleteTreatement={this.confirmDeleteTreatement}
              values={this.state}
            />
          ) : (
            ""
          )}
        </div>
      </StyleRoot>
    );
  }
}
